<template>
  <div>
    <v-text-field
      v-model="password"
      :label="$t('login.password')"
      single-line
      dense
      :type="showPassword ? 'text' : 'password'"
      :counter="MAX_PASSWORD_LENGTH"
      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
      @click:append="showPassword = !showPassword"
      :maxlength="MAX_PASSWORD_LENGTH"
      autocomplete="new-password"
      tabindex="2"
      hide-details
      :rules="[() => !!password || $t('forms.thisFieldIsRequired')]"
      outlined
      :disabled="getInProgress"
    >
    </v-text-field>
    <password v-model="password" :strength-meter-only="true" />
    <v-alert
      dense
      style="margin-left: auto; margin-right: auto"
      max-width="80%"
      text
      v-if="value.length > 0"
      :type="longEnough ? 'success' : 'error'"
      >{{ $t("register.minimumCharacters") }}</v-alert
    >
    <p max-width="80%" class="error-message" v-if="passwordPwned">
      {{ $t("register.passwordCompromised") }}
    </p>
    <v-text-field
      v-model="repeatPassword"
      :label="$t('register.confirmPassword')"
      single-line
      autocomplete="new-password"
      dense
      :type="showRepeatPassword ? 'text' : 'password'"
      :append-icon="showRepeatPassword ? 'mdi-eye' : 'mdi-eye-off'"
      @click:append="showRepeatPassword = !showRepeatPassword"
      :counter="MAX_PASSWORD_LENGTH"
      tabindex="3"
      :maxlength="MAX_PASSWORD_LENGTH"
      :rules="[
        () => password == repeatPassword || $t('register.passwordsMustMatch'),
        () => !!repeatPassword || $t('forms.thisFieldIsRequired'),
      ]"
      outlined
      :disabled="getInProgress"
    />
  </div>
</template>
<script>
import Password from "vue-password-strength-meter";
import debounce from "@/helpers/debounce";
import { MAX_PASSWORD_LENGTH, MIN_PASSWORD_LENGTH } from "@/const";
import { pwnedPassword } from "hibp";
export default {
  components: {
    Password,
  },
  props: {
    value: String,
    getInProgress: Boolean,
  },
  created() {
    this.MAX_PASSWORD_LENGTH = MAX_PASSWORD_LENGTH;
  },
  data() {
    return {
      repeatPassword: "",
      password: "",
      showPassword: false,
      showRepeatPassword: false,
      passwordPwned: false,
    };
  },
  methods: {
    checkPassword: debounce(async function (newValue) {
      pwnedPassword(newValue)
        .then((numPwns) => {
          if (numPwns > 0) {
            this.passwordPwned = true;
          } else {
            this.passwordPwned = false;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }, 500),
  },
  watch: {
    password(newValue) {
      if (newValue.length >= MIN_PASSWORD_LENGTH) {
        this.checkPassword(newValue);
      }
      else {
        this.passwordPwned = false;
      }

      this.$emit("input", newValue);
    },
    valid(newValue) {
      this.$emit("valid", newValue);
    },
  },
  computed: {
    longEnough() {
      return this.value.length >= MIN_PASSWORD_LENGTH;
    },
    valid() {
      return (
        this.value.length >= MIN_PASSWORD_LENGTH &&
        this.password == this.repeatPassword &&
        this.passwordPwned == false
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.error-message {
  color: #e62828;
  font-size: 0.8em;
}
</style>